import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  context.loading = false;
  context.btnSyncLocksDisabled = false;
  context.closeModal('#configure-key-modal');
  toastr.success(context.$t("rentals.detail.the_keys.keys_added"));
};

// When the request fails
const failed = (context, error) => {
  context.loading = false;
  context.btnSyncLocksDisabled = false;
  context.showToasterError(error);
};

export default (context, credentials) => {
  return Vue.$http.post('sync-the-keys-locks', credentials)
      .then((response) => {
        if (response.status === 200) {
          success(response, context);
        }
      })
      .catch((error) => {
        failed(context, error);
      });
};



// WEBPACK FOOTER //
// ./src/app/services/the_keys/sync.js